import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogLookupPermissionsComponent } from 'src/app/+home/+my-libraries/+sites/document-library/shared/dialog-lookup-permissions/dialog-lookup-permissions.component';
import { DialogLookupUsersGroupsComponent } from 'src/app/+home/shared/components/dialog-lookup-users-groups/dialog-lookup-users-groups.component';
import { User } from 'src/shared/models/user.class';
import { BoardService } from 'src/shared/services/board.service';

@Component({
  selector: 'see-affectation-kanban',
  templateUrl: './see-affectation-kanban.component.html',
  styleUrls: ['./see-affectation-kanban.component.scss']
})
export class SeeAffectationKanbanComponent implements OnInit {

  @Input() data;
  @Output() emitDeleteAffect: EventEmitter<string> = new EventEmitter();
  myArray: any[] = [];

  constructor(
    private matDialog: MatDialog,
    public boardService: BoardService,
    public dialogRef: MatDialogRef<DialogLookupUsersGroupsComponent>

    ) { }

  ngOnInit(){
    for(let i = 0; i< this.data.affect.length; i++){
      if(this.data.affect[i] == null){
        this.data.affect.splice(i, 1)
      }
    }

    this.data.affect.forEach((element) => {
      if (!this.myArray.includes(element)) {
        if(element !=null){
          this.myArray.push(element);
        }
      }
     });
  }




}
